import { useMutation, useQueryClient } from 'react-query';
import { trpc } from '../../../../lib/trpc';
import { getPropertyContactsKeys } from './propertyContactsQueries';
import { AddContactForm } from '../../components/Contacts/AddContactForm';
import { uploadToAws } from '../../../project-templates/hooks/ContentInformation/uploadToAws';

const useSavePropertyContact = () => {
    const client = useQueryClient();
    return useMutation(
        async ({ contact, property_id, file }: { contact: AddContactForm; property_id: number; file?: File }) => {
            const image = file
                ? {
                      name: file.name,
                      size: file.size,
                      type: file.type,
                  }
                : undefined;

            const { preSingedUrl, id } = await trpc.PropertyContactsApi.savePropertyContact.mutate({
                contact: { ...contact },
                propertyId: property_id,
                image,
            });

            if (preSingedUrl && file) {
                await uploadToAws({
                    preSingedUrl,
                    file,
                    cleanup: async () => {
                        await trpc.PropertyContactsApi.editPropertyContact.mutate({
                            contact,
                            contactId: id,
                        });
                    },
                });
            }

            return { id };
        },
        {
            onSettled: () => {
                client.invalidateQueries(getPropertyContactsKeys.lists());
            },
        },
    );
};

export default useSavePropertyContact;
